import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AppFilter } from '@app/shared/models';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { tap } from 'rxjs/operators';
import { OrganizationService } from 'src/modules/features/admin/services';
import { DocumentTypeService } from 'src/modules/features/setting/services';
import { CompanyService, DashboardProvider } from '../../services';

interface IViewHistoryModalContext {
  title: string;
  organization: any;
  data?: any;
}
@Component({
  selector: 'app-view-non-assessment-modal',
  templateUrl: './view-non-assessment-modal.component.html',
  styleUrls: ['./view-non-assessment-modal.component.scss'],
})
export class ViewNonAssessmentModalComponent implements OnInit {
  allPendingHistory;
  pendingHistory;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  allHistory: any = [];
  isPending: boolean = this.modal.context.data
    ? this.modal.context.data.isPending
    : false;
  isChecked: string;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'changeRequestType',
        op: 'cn',
        data: 'this.toEdit',
      },
    ],
  };
  collapseHistory = [];
  selectedRequest: any;
  detail: any;
  organizationData;
  extraData;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private documentTypeSvc: DocumentTypeService,
    public modal: SuiModal<IViewHistoryModalContext, void, void>,
    private companyOwnershipService: CompanyOwnershipService,
    private dashboardSvc: DashboardProvider
  ) {
    this.organizationData = this.modal.context.organization;
    this.extraData = this.modal.context.data;
    console.log(this.organizationData, this.extraData);
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
  }

  ngOnInit(): void {}
}

export class ViewNonAssessmentModal extends ComponentModalConfig<
  IViewHistoryModalContext,
  void,
  void
> {
  constructor(
    title: string,
    organization: any,
    data?: any,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(ViewNonAssessmentModalComponent, {
      title,
      organization,
      data,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
